import React from "react";
import { CrosshairIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-8 sm:pb-20 sm:pt-12" data-id="element-144" data-mp="9k0b6xwjpxkw">
      <div className="mx-auto max-w-5xl text-center" data-id="element-145" data-mp="4lqf8l2zysy8">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-146" data-mp="4na0yr7f9w7e">
          <div className="flex items-center gap-2" data-id="element-147" data-mp="128fq7kfogfw8">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-wine-700 text-white" data-id="element-148" data-mp="1274nlnxyxe6p">
              <CrosshairIcon className="h-5 w-5" aria-hidden="true" data-id="element-149" data-mp="sbb1bcug66bq" />
            </span>
            <span className="font-serif text-xl font-bold text-wine-900" data-id="element-150" data-mp="sd4bv386lap0">War Room™</span>
          </div>
          <span className="rounded-full border border-wine-200 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-wine-700" data-id="element-151" data-mp="3d1ikzavvpeny">
            Biomechanics War Room™
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[2.15rem] font-extrabold leading-[1.1] text-ink sm:text-5xl lg:text-6xl" data-id="element-152" data-mp="3j8iv8twpu6s2">
          Train your biomechanical judgment with 50 clinical challenges —{" "}
          <em className="text-wine-700" data-id="element-153" data-mp="39ausbgoyhsyt">and structure your analysis in 10 minutes or less</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-soft sm:text-xl" data-id="element-154" data-mp="3e8mur4n88xh9">
          A visual, case-based training system to analyze complex orthodontic biomechanics, compare different approaches, and understand the reasoning behind each case. Includes{" "}
          <strong className="text-ink" data-id="element-155" data-mp="2qk3i6cx59yjd">6 premium volumes</strong>, <strong className="text-ink" data-id="element-156" data-mp="2qloea6z3xpjc">5 professional tools</strong> and{" "}
          <strong className="text-ink" data-id="element-157" data-mp="2vjpy4u4cxsvv">50 biomechanical challenges</strong>.
        </p>

        <img src={images.product} alt="Biomechanics War Room™: 6 volumes, decision maps, worksheets and 5 bonuses" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-158" data-mp="2hk83vz8alnf4" />

        <p className="mb-5 font-serif text-lg font-bold text-wine-900 sm:text-xl" data-id="element-159" data-mp="s335feo1gqy2">
          The 6 volumes + 5 bonuses inside Biomechanics War Room™
        </p>

        <CtaButton id="hero-cta" label="I want to train my biomechanical judgment" note="Instant access · One-time payment of $27 USD · Lifetime access · 7-Day Guarantee" data-id="element-160" data-mp="ic87ve5ce4xb" />
        <Countdown data-id="element-161" data-mp="1b0nilohfy12u" />
        <p className="mx-auto mt-5 max-w-md text-sm text-ink-soft" data-id="element-162" data-mp="1b15lh3ylzdjq">
          Get BIOMECHANICS WAR ROOM™ at the special launch price. <br className="hidden sm:block" data-id="element-163" data-mp="162c7zbjbnmjk" />
          Your currency will be automatically converted according to your country.
        </p>
      </div>
    </header>;
}